import { render, staticRenderFns } from "./ShowJyClassify.vue?vue&type=template&id=6f32131c&scoped=true&"
import script from "./ShowJyClassify.vue?vue&type=script&lang=js&"
export * from "./ShowJyClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f32131c",
  null
  
)

export default component.exports